// extracted by mini-css-extract-plugin
module.exports = {"link":"_7a3fb80146--link--Udy7o","arrow":"_7a3fb80146--arrow--A6LkA"};